import fileTypeIcon from './filetype-icons';

/**
 * Retrieves the corresponding icon for a given MIME type.
 *
 * @param {String} mime - The MIME type of the file.
 * @return {String} - The file path to the corresponding icon or the default icon if the MIME type is not recognized.
 */
const getFileIconByMime = ( mime ) => {
	return fileTypeIcon[ mime ] || fileTypeIcon.default;
}

export default getFileIconByMime;
